"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/range");
require("rxjs/add/operator/map");
exports.slicenator = function (blob, _a) {
    var chunkSize = _a.size;
    var totalChunks = Math.ceil(blob.size / chunkSize);
    return Observable_1.Observable.range(0, totalChunks).map(function (index) {
        return blob.slice(index * chunkSize, (index + 1) * chunkSize);
    });
};
//# sourceMappingURL=slicenator.js.map